import { render, staticRenderFns } from "./SensitiveData.vue?vue&type=template&id=552eba36&scoped=true"
var script = {}
import style0 from "./SensitiveData.vue?vue&type=style&index=0&id=552eba36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552eba36",
  null
  
)

export default component.exports